import { render } from "./GameScreen.vue?vue&type=template&id=465d5070"
import script from "./GameScreen.vue?vue&type=script&lang=js"
export * from "./GameScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Apps/visma_reaction_game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__